export type TeamRole = 'OWNER' | 'COMPLIANCE_OFFICER' | 'MARKETING_MANAGER' | 'MARKETING_MEMBER' | 'VIEWER';

export type Permission =
  | 'report.create'
  | 'report.view_own'
  | 'report.view_team'
  | 'report.view_all'
  | 'report.edit_own'
  | 'report.edit_team'
  | 'report.delete_own'
  | 'report.delete_team'
  | 'report.submit_for_approval'
  | 'report.export'
  | 'approval.review'
  | 'approval.approve'
  | 'approval.reject'
  | 'team.manage_members'
  | 'team.manage_roles'
  | 'team.manage_settings'
  | 'team.view_audit_logs'
  | 'team.view_analytics'
  | 'compliance.read'
  | 'compliance.write'
  | 'ad_metadata.edit'
  | 'comment.create'
  | 'comment.view'
  | 'comment.resolve'
  | 'checklist.manage'
  | 'checklist.complete'
  | 'checklist.view'
  | 'exam_package.generate';

export const ROLE_LABELS: Record<TeamRole, string> = {
  OWNER: 'Owner',
  COMPLIANCE_OFFICER: 'Compliance Officer',
  MARKETING_MANAGER: 'Marketing Manager',
  MARKETING_MEMBER: 'Marketing Member',
  VIEWER: 'Viewer',
};

export const ROLE_COLORS: Record<TeamRole, { bg: string; text: string; dot: string }> = {
  OWNER: { bg: 'bg-amber-100', text: 'text-amber-800', dot: 'bg-amber-500' },
  COMPLIANCE_OFFICER: { bg: 'bg-blue-100', text: 'text-blue-800', dot: 'bg-blue-500' },
  MARKETING_MANAGER: { bg: 'bg-cyan-100', text: 'text-cyan-800', dot: 'bg-cyan-500' },
  MARKETING_MEMBER: { bg: 'bg-indigo-100', text: 'text-indigo-800', dot: 'bg-indigo-500' },
  VIEWER: { bg: 'bg-gray-100', text: 'text-gray-800', dot: 'bg-gray-500' },
};

/** Roles that can submit reports for review */
export const CAN_SUBMIT_ROLES: TeamRole[] = ['OWNER', 'MARKETING_MANAGER', 'MARKETING_MEMBER'];

/** Roles that can approve/reject reports */
export const CAN_REVIEW_ROLES: TeamRole[] = ['OWNER', 'COMPLIANCE_OFFICER'];

/** Roles that can manage team members */
export const CAN_MANAGE_TEAM_ROLES: TeamRole[] = ['OWNER'];

/** Assignable roles (can't assign OWNER via dropdown) */
export const ASSIGNABLE_ROLES: TeamRole[] = ['COMPLIANCE_OFFICER', 'MARKETING_MANAGER', 'MARKETING_MEMBER', 'VIEWER'];
